<!-- @veltra/icons generated sha256:8aa7e19a3971f845 gen:8 source:src/svg/normal/circle-check-filled.svg -->
<script setup lang="ts">
defineOptions({ name: 'CircleCheckFilled' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14M4.843 7.864l.008-.008a.504.504 0 0 1 .71-.002L7 9.293l3.443-3.443a.483.483 0 0 1 .693-.007l.008.008a.506.506 0 0 1 0 .712l-3.788 3.789a.5.5 0 0 1-.709.002L4.853 8.56a.486.486 0 0 1-.01-.695"
    />
  </svg>
</template>
